import React from 'react';
import { Box, Card, CardContent } from '@mui/material';
import styles from './LibraryCategoryCard.module.scss';
import { LibraryCategoryCardProps } from './types';
import { useTranslation } from 'react-i18next';
import PreviewTooltip from '../preview-block/PreviewTooltip';
import InfoIcon from '@mui/icons-material/Info';

const LibraryCategoryCard: React.FC<LibraryCategoryCardProps> = ({
  title,
  description,
  onClick,
  icon,
  hasFreeLabel,
  hasNewLabel,
  previewBlock,
}) => {
  const { t } = useTranslation();
  return (
    <Card
      onClick={onClick}
      className={styles.card}
      sx={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <CardContent className={styles.card_content}>
        <Box className={styles.category_name_container}>
          <h3 className={styles.category_name}>{title}</h3>
        </Box>
        {description && <p className={styles.category_description}>{description}</p>}
        {icon && <Box className={styles.icon_container}>{icon}</Box>}
        {hasFreeLabel && <Box className={styles.free_label}>{t('labels.free')}</Box>}
        {hasNewLabel && <Box className={styles.new_label}>{t('labels.new')}</Box>}
        {previewBlock && (
          <PreviewTooltip title={previewBlock} arrow placement='bottom'>
            <InfoIcon className={styles.preview_icon} color='primary' fontSize='small' />
          </PreviewTooltip>
        )}
      </CardContent>
    </Card>
  );
};

export default LibraryCategoryCard;
